import React, { useEffect } from 'react';
import RCSlider from 'rc-slider';

import SliderTooltip from './components/slider-tootip/slider-tooltip';

import './slider.scss';

interface SliderProps {
  markerPrefix?: string;
  markerSuffix?: string;
  max: number;
  min: number;
  onChange: (value: number) => void;
  showTooltip?: boolean;
  value: number;
}

function Slider(props: SliderProps) {
  const {
    markerPrefix = '',
    markerSuffix = '',
    max,
    min,
    onChange,
    showTooltip = false,
    value: proposedValue
  } = props;
  const value = (() => {
    if (proposedValue < min) {
      return min;
    } else if (proposedValue > max) {
      return max;
    } else {
      return proposedValue;
    }
  })();

  useEffect(() => {
    if (value !== proposedValue) {
      onChange(value);
    }
  });

  return (
    <div className={showTooltip ? 'slider__tooltip' : 'slider'}>
      <div className="slider__markers">
        <span className="slider__marker">{markerPrefix}</span>
        <span className="slider__marker">{markerSuffix}</span>
      </div>
      <RCSlider
        handle={showTooltip ? SliderTooltip : undefined}
        max={max}
        min={min}
        onChange={onChange}
        value={value}
      />
    </div>
  );
}

export default Slider;
